import { ArrowDecisionAutoIcon } from './ArrowDecisionAutoIcon';

/**
 * author: Michael Richins
 * id B115DB5B-AAF9-4C39-BC44-9E573E3154A1
 * name arrow-decision-auto
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-decision-auto.svg
 * tags
 */
export const ProxyAutoIcon = ArrowDecisionAutoIcon;
export default ProxyAutoIcon